module.exports = __webpack_public_path__ + "img/bag_2.e4a75b6d.svg";